// ===================================
// KAIXO - API de boosts (anuncios pagados)
// ===================================

import api from './api';

const B = '/boosts';

function uid() {
    try { return JSON.parse(localStorage.getItem('kaixo_user') || '{}')._id || ''; }
    catch { return ''; }
}

// Normaliza boostId que puede llegar como objeto (socket, populate de Mongo).
function id(v) {
    if (!v) return '';
    if (typeof v === 'string') return v === '[object Object]' ? '' : v;
    if (typeof v === 'object') {
        if (typeof v.toHexString === 'function') {
            try { return v.toHexString(); } catch { /* noop */ }
        }
        return String(v._id || v.id || '');
    }
    return String(v);
}

export const boostGetConfig = () => api.get(`${B}/config/public`);
export const boostEstimate = (data) => api.post(`${B}/estimate`, { ...data, userId: uid() });
export const boostCreate = (data) => api.post(`${B}`, { ...data, userId: uid() });
export const boostListMine = (params) => api.get(`${B}/my`, { params: { ...params, userId: uid() } });
export const boostGetOne = (boostId) => api.get(`${B}/${id(boostId)}`, { params: { userId: uid() } });
export const boostPause = (boostId) => api.post(`${B}/${id(boostId)}/pause`, { userId: uid() });
export const boostResume = (boostId) => api.post(`${B}/${id(boostId)}/resume`, { userId: uid() });
// PENDIENTE UX (sprint pre-lanzamiento): antes de invocar boostCancel,
// el componente que lo llama (CRMAds.js u otro) debe mostrar un modal
// de confirmación advirtiendo:
//   "Has gastado X de Y créditos. Los Z créditos restantes volverán a
//    tu balance de KAIXO para usar en futuras campañas. NO se devuelven
//    a tu tarjeta. ¿Cancelar el boost?"
// El response del backend ahora devuelve `creditsAddedToBalance` (no
// `refundCents` antiguo). Mostrar ese valor al usuario tras la
// cancelación: "✓ Se añadieron X créditos a tu balance".
export const boostCancel = (boostId) => api.post(`${B}/${id(boostId)}/cancel`, { userId: uid() });
export const boostStats = (boostId) => api.get(`${B}/${id(boostId)}/stats`, { params: { userId: uid() } });
